/**
 *  TemplateDetail script file
**/
import templatesService from '@/api/templatesService'

export default {
  name: 'TemplateDetail',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      loading: true,
      template: null
    }
  },
  computed: {
  },
  async mounted () {
    this.loading = true
    this.$emit('selectTab', { id: 'templates' })
    this.template = await templatesService.getTemplate({ id: this.$route.params.templateid })
    this.loading = false
  },
  methods: {
    closeModal () {
      this.$router.push('/administration')
    },
    async removeTemplate () {
      await templatesService.deleteTemplate(this.template)
      this.$router.push({ path: `/administration` })
      this.$emit('delete', { type: 'templates' })
    }
  }
}
